import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectSprayEventTypeIsWeed } from 'services/sprayEventType/selectors';

const selectSprayJustificationOptions = createDeepEqualSelector(
    selectSprayEventTypeIsWeed,
    (isWeedSpray) => {
        const defaultOptions = [
            'Final Cover',
            'Fireblight',
            'Foward Cover',
            'Fruit Rots',
            'Growth regulation',
            'N.alba & Monilinia spp',
            'Pit & Blotch',
            'Post infection (kickback)',
            'Powdery Mildew',
            'Recommended',
            'Thinning',
            'Threshold exceeded'
        ];
        const weedSprayOptions = [
            'Herbicide – Knock down',
            'Herbicide – Pre-emergent'
        ];
        const options = isWeedSpray
            ? [...defaultOptions, ...weedSprayOptions]
            : defaultOptions;

        return options.sort().map((option) => ({
            key: option,
            text: option,
            value: option
        }));
    }
);

export { selectSprayJustificationOptions };
